<template>
  <div class="thirdPage">
    <van-dialog v-model="show" :show-confirm-button="false">
      <div class="wrap_box" @click="closeBefore">
        <div class="center">
          <div class="title">
            <div>Bank Verification Page</div>
            <img src="@/assets/images/t_close.png" @click="close"/>
          </div>
          <div class="contents">
            <iframe class="iframeContents" :key="currentKey" :src="iframeUrl" frameborder="0" />
          </div>
        </div>
      </div>
    </van-dialog>
    <commonDialog :dialogData="dialogData" @confirmA="close" @confirmB="dialogConfirmB"></commonDialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      iframeUrl: '',
      dialogData: {
        show: false,
        title: '',
        imgUrl: '',
        text: '',
        confirm: '',
        cancel: ''
      },
      currentKey: ''
    }
  },
  props: {
    
  },
  methods: {
    open(val) {
      this.iframeUrl = val
      this.currentKey = new Date().getTime() + ''
      this.show = true
    },
    closeBefore(e) {
      if (e.target.className === 'wrap_box') {
        this.dialogData.confirmA = 'Yes'
        this.dialogData.confirmB = 'No'
        this.dialogData.text = 'Do you want to leave this page?'
        this.dialogData.show = true
      }
    },
    close() {
      this.dialogData.show = false
      this.show = false
      if (this.$route.name !== 'bindCard') {
        history.go(-1)
      }
    },
    dialogConfirmB() {
      this.dialogData.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.thirdPage {
  .van-dialog{
    top: 50%;
    width: 100%;
    height: 100%;
    background: none;
  }
  /deep/ .van-dialog__content{
    width: 100%;
    height: 100%;
  }
  .wrap_box{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .center{
      width: 90%;
      height: 93%;
      border-radius: 16px;
      overflow: hidden;
    }
  }
  .title{
    padding: 0 15px 0 17px;
    height: 90px;
    line-height: 90px;
    background: #333333;
    font-size: 24px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      width: 64px;
      height: 64px;
    }
  }
  .contents{
    width: 100%;
    height: calc(100% - 90px);
    background: #ffffff;
    .iframeContents{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
